import { useCallback, useEffect, useRef, useState } from "react";

const useResizeObserver = () => {
  const [isMobileView, setIsMobileView] = useState<boolean>(
    window.innerWidth < 1024
  );
  const mobileRef = useRef<boolean>(false);

  const resizeHandler = useCallback(() => {
    if (window.innerWidth > 1024) {
      if (mobileRef.current !== false) {
        setIsMobileView(false);
        mobileRef.current = false;
      }
    } else if (mobileRef.current !== true) {
      setIsMobileView(true);
      mobileRef.current = true;
    }
  }, []);

  useEffect(() => {
    window.addEventListener("resize", resizeHandler);

    return () => {
      window.removeEventListener("resize", resizeHandler);
    };
  }, [resizeHandler]);

  return isMobileView;
};

export default useResizeObserver;
